<!-- TOP COMMON AREA -->
<div class="dashboard-cards-wrap mt-3 mb-4">
	<eif-dashboard-card
		value="{{ saphetyComission | currencyLocale: CurrencyCode.Euro }}"
		description="{{ 'dashboard-administrator.saphetyComission' | translate }} ({{ CurrentMonth }})"
		[icon]="'fa-regular fa-sack-dollar'"
		[loading]="loadingSaphetyComission"
		[color]="'1'"
		(action)="navigateToSovosCommissions()" />
	<eif-dashboard-card
		value="{{ totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections }}"
		description="{{ 'dashboard-administrator.totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections' | translate }}"
		[icon]="'fa-regular fa-building'"
		[loading]="loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections"
		[color]="'2'" />
	<eif-dashboard-card
		value="{{ totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts }}"
		description="{{ 'dashboard-administrator.totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts' | translate }}"
		[icon]="'fa-regular fa-building'"
		[loading]="loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts"
		[color]="'3'" />
	<eif-dashboard-card
		value="{{ totalActiveConnections }}"
		description="{{ 'dashboard-administrator.totalActiveConnections' | translate }}"
		[icon]="'fa-regular fa-chart-network'"
		[loading]="loadingTotalActiveConnections"
		[color]="'8'" />
</div>

<!-- TABS -->
<div class="grid-row tabs dashboard-tabs mb-4">
	<ul class="ps-0 mb-0">
		<!-- CONFIRMING -->
		@if (confirmingTabVisible) {
			<li
				[ngClass]="{
					'': !confirmingTabSelected,
					'is-active': confirmingTabSelected,
				}">
				<a (click)="clickedConfirmingTab()">
					{{ 'menu.Confirming' | translate }}
				</a>
			</li>
		}
		<!-- FACTORING -->
		@if (factoringTabVisible) {
			<li
				[ngClass]="{
					'': !factoringTabSelected,
					'is-active': factoringTabSelected,
				}">
				<a (click)="clickedFactoringTab()">
					{{ 'menu.Factoring' | translate }}
				</a>
			</li>
		}
	</ul>

	<!-- REFRESH BUTTON -->
	<eif-custom-button
		[text]="'button.refresh' | translate"
		[preIcon]="'fa-solid fa-sync-alt'"
		(action)="refreshAllData()">
	</eif-custom-button>
</div>
<!-- CONFIRMING AREA -->
@if (confirmingTabSelected) {
	<div class="grid-row">
		<!-- CURRENCIES -->
		@if (orderedCurrencies.length > 1) {
			<ul class="currency-wrap mt-0 mb-4">
				@for (orderedCurrency of orderedCurrencies; track orderedCurrency.Currency; let i = $index) {
					<li>
						<eif-custom-button
							[text]="orderedCurrency.Currency"
							[variant]="orderedCurrency.Selected ? 'standard' : 'outlined'"
							[color]="orderedCurrency.Selected ? 'primary' : 'neutral'"
							(action)="clickedCurrency(orderedCurrency.Currency)">
						</eif-custom-button>
					</li>
				}
			</ul>
		}
		@if (confirmingTabSelected) {
			<div class="dashboard-cards-wrap">
				<eif-dashboard-card
					value="{{ confirmingApprovedRequestFunds | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-administrator.approvedRequestFunds' | translate }}"
					[icon]="'fa-regular fa-hand-holding-dollar'"
					[loading]="loadingConfirmingApprovedRequestFunds"
					[color]="'1'" />
				<eif-dashboard-card
					value="{{ confirmingCurrentFundingRequestsAmount | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-administrator.currentFundingRequestsAmount' | translate }}"
					[icon]="'fa-regular fa-hand-holding-dollar'"
					[loading]="loadingConfirmingCurrentFundingRequestsAmount"
					[color]="'2'" />
				<eif-dashboard-card
					value="{{ confirmingAverageMonthFundingRequestDays }}"
					description="{{ 'dashboard-administrator.averageMonthFundingRequestDays' | translate }}"
					[icon]="'fa-regular fa-clock'"
					[loading]="loadingConfirmingAverageMonthFundingRequestDays"
					[color]="'3'" />
				<eif-dashboard-card
					value="{{ confirmingMonthlyAutomaticPayments | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-administrator.monthlyAutomaticPayments' | translate }}"
					[icon]="'fa-regular fa-usd-circle'"
					[loading]="loadingConfirmingMonthlyAutomaticPayments"
					[color]="'4'" />
				<eif-dashboard-card
					value="{{ confirmingNotPaidDocuments | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-administrator.notPaidDocuments' | translate }}"
					[icon]="'fa-regular fa-file-invoice'"
					[loading]="loadingConfirmingNotPaidDocuments"
					[color]="'5'" />
				<eif-dashboard-card
					value="{{ confirmingContractedAmount | currencyLocale: selectedCurrency }}"
					description="{{ 'dashboard-administrator.contractedAmount' | translate }}"
					[icon]="'fa-regular fa-chart-pie-simple-circle-dollar'"
					[loading]="loadingConfirmingContractedAmount"
					[color]="'6'" />
				<eif-dashboard-card
					value="{{ confirmingContractsAvailableAmount | currencyLocale: selectedCurrency }}"
					subValue="{{ confirmingContractsAvailableAmountRatio | numberLocale: '1.2-2' }}%"
					description="{{ 'dashboard-administrator.contractsAvailableAmount' | translate }}"
					[icon]="'fa-regular fa-chart-pie-alt'"
					[loading]="loadingConfirmingContractsAvailableAmount"
					[color]="'1'" />
				<eif-dashboard-card
					value="{{ confirmingBuyersWithActiveContractsCompaniesCount }}"
					description="{{ 'dashboard-administrator.buyersCompaniesCount' | translate }}"
					[icon]="'fa-regular fa-building'"
					[loading]="loadingConfirmingBuyersWithActiveContractsCompaniesCount"
					[color]="'2'" />
				<eif-dashboard-card
					value="{{ confirmingSuppliersWithActiveConnectionsCompaniesCount }}"
					description="{{ 'dashboard-administrator.suppliersCompaniesCount' | translate }}"
					[icon]="'fa-regular fa-building'"
					[loading]="loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount"
					[color]="'3'" />
				<eif-dashboard-card
					value="{{ confirmingSuppliersActiveConnections }}"
					description="{{ 'dashboard-administrator.suppliersActiveConnections' | translate }}"
					[icon]="'fa-regular fa-chart-network'"
					[loading]="loadingConfirmingSuppliersActiveConnections"
					[color]="'8'" />
				<eif-dashboard-card
					value="{{ confirmingPendingApprovalDocumentsAmount }}"
					description="{{ 'dashboard-administrator.confirmingPendingApprovalDocumentsAmount' | translate }}"
					[icon]="'fa-regular fa-hourglass-clock'"
					[loading]="loadingConfirmingPendingApprovalDocumentsAmount"
					[color]="'7'"
					(action)="navigateToFilesIntegration(FileStatus.PendingBuyerApproval)" />
			</div>
		}
	</div>
}
<!-- FACTORING AREA -->
@if (factoringTabVisible) {
	<div class="grid-row">
		@if (factoringTabSelected) {
			<div class="dashboard-cards-wrap">
				<eif-dashboard-card
					value="{{ factoringApprovedCreditAssignments | currencyLocale: CurrencyCode.Euro }}"
					description="{{ 'dashboard-administrator.factoringApprovedCreditAssignments' | translate }} ({{ CurrentMonth }})"
					[icon]="'fa-regular fa-hands-usd'"
					[loading]="loadingFactoringApprovedCreditAssignments"
					[color]="'1'" />
				<eif-dashboard-card
					value="{{ factoringCurrentCreditAssignmentsAmount | currencyLocale: CurrencyCode.Euro }}"
					description="{{ 'dashboard-administrator.factoringCurrentCreditAssignmentsAmount' | translate }}"
					[icon]="'fa-regular fa-hands-usd'"
					[loading]="loadingFactoringCurrentCreditAssignmentsAmount"
					[color]="'2'" />
				<eif-dashboard-card
					value="{{ factoringApprovedAdvances | currencyLocale: CurrencyCode.Euro }}"
					description="{{ 'dashboard-administrator.factoringApprovedAdvances' | translate }} ({{ CurrentMonth }})"
					[icon]="'fa-regular fa-money-check-alt'"
					[loading]="loadingFactoringApprovedAdvances"
					[color]="'3'" />
				<eif-dashboard-card
					value="{{ factoringContractedAmount | currencyLocale: CurrencyCode.Euro }}"
					description="{{ 'dashboard-administrator.factoringContractedAmount' | translate }}"
					[icon]="'fa-regular fa-chart-pie-simple-circle-dollar'"
					[loading]="loadingFactoringContractedAmount"
					[color]="'4'" />
				<eif-dashboard-card
					value="{{ factoringContractDocumentPortfolioAmount | currencyLocale: CurrencyCode.Euro }}"
					description="{{ 'dashboard-administrator.factoringContractDocumentPortfolioAmount' | translate }}"
					[icon]="'fa-regular fa-chart-pie-alt'"
					[loading]="loadingFactoringContractDocumentPortfolioAmount"
					[color]="'5'" />
				<eif-dashboard-card
					value="{{ factoringContractAdvanceableAmount | currencyLocale: CurrencyCode.Euro }}"
					description="{{ 'dashboard-administrator.factoringContractAdvanceableAmount' | translate }}"
					[icon]="'fa-regular fa-chart-pie-alt'"
					[loading]="loadingFactoringContractAdvanceableAmount"
					[color]="'6'" />
				<eif-dashboard-card
					value="{{ factoringSuppliersWithActiveContractsCompaniesCount }}"
					description="{{ 'dashboard-administrator.factoringSuppliersWithActiveContractsCompaniesCount' | translate }}"
					[icon]="'fa-regular fa-building'"
					[loading]="loadingFactoringSuppliersWithActiveContractsCompaniesCount"
					[color]="'1'" />
				<eif-dashboard-card
					value="{{ factoringBuyersWithActiveConnectionsCompaniesCount }}"
					description="{{ 'dashboard-administrator.factoringBuyersWithActiveConnectionsCompaniesCount' | translate }}"
					[icon]="'fa-regular fa-building'"
					[loading]="loadingFactoringBuyersWithActiveConnectionsCompaniesCount"
					[color]="'3'" />
				<eif-dashboard-card
					value="{{ factoringBuyersActiveConnections }}"
					description="{{ 'dashboard-administrator.factoringBuyersActiveConnections' | translate }}"
					[icon]="'fa-regular fa-chart-network'"
					[loading]="loadingFactoringBuyersActiveConnections"
					[color]="'8'" />
				<eif-dashboard-card
					value="{{ factoringPendingApprovalDocumentsAmount }}"
					description="{{ 'dashboard-administrator.factoringPendingApprovalDocumentsAmount' | translate }}"
					[icon]="'fa-regular fa-hourglass-clock'"
					[loading]="loadingFactoringPendingApprovalDocumentsAmount"
					[color]="'7'"
					(action)="navigateToFilesIntegration(FileStatus.PendingSupplierApproval)" />
			</div>
		}
	</div>
}
